import { StepConfig } from '@/classes/StepConfig';
import { FieldStatus } from '@/classes/FieldStatus';

/**
 * Check if a field has errors, according to a fieldStatus map by field path.
 * @param fieldPath the checked field
 * @param step the checked step
 * @param fieldErrorMapByPath map of field path - field error
 */
export function checkFieldHasError(
  fieldPath: string,
  step: StepConfig,
  fieldErrorMapByPath: Map<string, FieldStatus>
): boolean {
  const status = fieldErrorMapByPath.get(fieldPath);
  if (!status) return false;

  const allFieldErrors = Array.from(fieldErrorMapByPath.entries())
    .filter(([field]) => field.startsWith(fieldPath))
    .flatMap(([field, fieldStatus]) => [field, ...subFieldErrorsFromRules(fieldStatus)]);
  if (status.ruleMessages.length === 0 && isLeafError(fieldPath, allFieldErrors)) {
    return true;
  }

  const leafFieldErrors = allFieldErrors.filter(path => isLeafError(path, allFieldErrors));
  const hasErrorOnNotExcludedField = leafFieldErrors.some(fieldInError => !step.excludedFields.includes(fieldInError));
  return hasErrorOnNotExcludedField;
}

function isLeafError(field: string, fieldErrors: string[]): boolean {
  const subErrorPaths = fieldErrors.filter(path => path.startsWith(field + '.'));
  return subErrorPaths.length === 0;
}

function subFieldErrorsFromRules(status: FieldStatus): string[] {
  return status.ruleMessages.flatMap(msg => msg.fields);
}
